import { filter, get } from 'lodash';

import { APP_ACCESS_MATRIX } from '../../../config/accessMatrix';

export class PermissionService {
    constructor() {}

    getPermissionRoles(action: string): string[] {
        const actionAllowedRoles: string[] = get(APP_ACCESS_MATRIX, action) ?? [];
        return filter(actionAllowedRoles, (role) => !!role);
    }
}
